import camelot from './papi.camelot';
import legacy from './papi.legacy';
// import axios from 'axios';
// import env from './env';
import store from '@/store';
import auth from '@/api/auth';

export default {

	//login and user helpers

	//UPDATED - on for everyone
	camelot: true,

	get isCamelot()
	{
		return this.camelot;
	},

	setup() {

		if(this.isCamelot)
		{
			return camelot.setup()
		} else {
			return legacy.setup();
		}
	},

	async loadJwt() {


		const jwt = await auth.getCredentials();
		if(!jwt) return;

		let id;
		try {
			const community = store.getters['settings/value']('community')
			const { communityId } = JSON.parse(community);
			id = communityId;
			
		} catch(e) {
			console.log('unable to get communityId for camelot check')
		}

		if(!id)
		{
			//get from jwt
			const decoded = auth.parseJwt(jwt);
			id = decoded.residentCommunityId || decoded.communities[0];
			console.log(`got community id from jwt ${id}`);
		}
		

		// try {
		
		// 	const { data } = await axios.get(`https://k4connect-shared.s3.us-east-1.amazonaws.com/camelot/camelot.enabled.${env.name()}.json`);
		// 	this.camelot = data.indexOf('*') > -1 || data.indexOf(String(id)) > -1;
			
		// } catch(e) {
		// 	console.log('unable to get s3 file for camelot check')
		// }

		// console.log(`isCamelot ${this.camelot}`);

		// if(process.env.VUE_APP_LOCAL_CAMELOT)
		// {
		// 	this.camelot = true;
		// }

		if(this.isCamelot)
		{
			return camelot.loadJwt(jwt)
		} else {
			return legacy.loadJwt(jwt);
		}
	},

	async init()
	{
		if(this.isCamelot)
		{
			return camelot.init()
		} else {
			return legacy.init();
		}
	},

	async createDevice(device)
	{
		if(this.isCamelot)
		{
			return camelot.createDevice(device)
		}
	},


	async getHomeControls(password)
	{

		if(this.isCamelot)
		{
			return camelot.getHomeControls(password)
		} else {
			return legacy.getHomeControls(password);
		}
	
	},

	async share(firstName, lastName, email, relationship, primaryPhone = null)
	{
		if(this.isCamelot)
		{
			return camelot.share(firstName, lastName, email, relationship, primaryPhone)
		} else {
			return legacy.share(firstName, lastName, email, relationship, primaryPhone);
		}
	},

	async updateProfile(biography)
	{
		if(this.isCamelot)
		{
			return camelot.updateProfile(biography)
		} else {
			return legacy.updateProfile(biography);
		}
	},

	async updateOptOutSettings(optOutOfDirectory) {
		if(this.isCamelot)
		{
			return camelot.updateOptOutSettings(optOutOfDirectory)
		} else {
			return legacy.updateOptOutSettings(optOutOfDirectory);
		}
	},

	async updateOptOutFields(fields) {
		if(this.isCamelot)
		{
			return camelot.updateOptOutFields(fields)
		} else {
			return legacy.updateOptOutFields(fields);
		}
	},

	async updateExposeFields(fields) {
		if(this.isCamelot)
		{
			return camelot.updateExposeFields(fields)
		} else {
			return legacy.updateExposeFields(fields);
		}
	},

	// feed helpers


	async getHome(from, after, limit = 50)
	{
		if(this.isCamelot)
		{
			return camelot.getHome(from, after, limit)
		} else {
			return legacy.getHome(from, after, limit);
		}
	},

	async getFeed(category, tags, after, limit = 50)
	{
		if(this.isCamelot)
		{
			return camelot.getFeed(category, tags, after, limit)
		} else {
			return legacy.getFeed(category, tags, after, limit);
		}
	},

	async getFeedItem(id)
	{
		if(this.isCamelot)
		{
			return camelot.getFeedItem(id)
		} else {
			return legacy.getFeedItem(id);
		}
	},

	async submitForm(id, values)
	{
		if(this.isCamelot)
		{
			return camelot.submitForm(id, values)
		} else {
			return legacy.submitForm(id, values);
		}
	},



	//dining

	async getRestaurants(first = 50)
	{
		if(this.isCamelot)
		{
			return camelot.getRestaurants(first)
		} else {
			return legacy.getRestaurants(first);
		}
	},

	async getMenus(restaurantId, first = 50)
	{
		if(this.isCamelot)
		{
			return camelot.getMenus(restaurantId, first)
		} else {
			return legacy.getMenus(restaurantId, first);
		}
	},

	async getMenu(restaurantId, menuId, date, first = 50, timeframe = 'Day')
	{
		if(this.isCamelot)
		{
			return camelot.getMenu(restaurantId, menuId, date, first, timeframe)
		} else {
			return legacy.getMenu(restaurantId, menuId, date, first, timeframe);
		}
	},


	//directory

	async getDirectory(communityId)
	{
		if(this.isCamelot)
		{
			return camelot.getDirectory(communityId)
		} else {
			return legacy.getDirectory(communityId);
		}
	},

	async getDetails(id)
	{
		if(this.isCamelot)
		{
			return camelot.getDetails(id)
		} else {
			return legacy.getDetails(id);
		}
	},

	async searchDirectory(communityId, query, roles)
	{
		if(this.isCamelot)
		{
			return camelot.searchDirectory(communityId, query, roles)
		} else {
			return legacy.searchDirectory(communityId, query, roles);
		}
	},

	async alexaAddressBook() {
		if(this.isCamelot)
		{
			return camelot.alexaAddressBook()
		} else {
			return legacy.alexaAddressBook();
		}
	},

	async addAlexaContact({ roomName, phoneNumber, contactName } = {}) {
		if(this.isCamelot)
		{
			return camelot.addAlexaContact({ roomName, phoneNumber, contactName })
		} else {
			return legacy.addAlexaContact({ roomName, phoneNumber, contactName });
		}
	},

	async removeAlexaContact({ roomName, contactName } = {}) {
		if(this.isCamelot)
		{
			return camelot.removeAlexaContact({ roomName, contactName })
		} else {
			return legacy.removeAlexaContact({ roomName, contactName });
		}
	},

	//events

	async getEvents(page, limit, timeframe, price, calendars, search)
	{
		if(this.isCamelot)
		{
			return camelot.getEvents(page, limit, timeframe, price, calendars, search)
		} else {
			return legacy.getEvents(page, limit, timeframe, price, calendars, search);
		}
	},


	async getEvent(eventId)
	{
		if(this.isCamelot)
		{
			return camelot.getEvent(eventId)
		} else {
			return legacy.getEvent(eventId);
		}
	},

	async getMyEvents()
	{
		if(this.isCamelot)
		{
			return camelot.getMyEvents()
		} else {
			return legacy.getMyEvents();
		}
	},

	async getMyInvites()
	{
		if(this.isCamelot)
		{
			return camelot.getMyInvites()
		} else {
			return legacy.getMyInvites();
		}
	},

	async attendEvent(eventId, guests = [], comments = null)
	{
		if(this.isCamelot)
		{
			return camelot.attendEvent(eventId, guests, comments)
		} else {
			return legacy.attendEvent(eventId, guests, comments);
		}
	},

	async withdrawEvent(eventId, rsvpId)
	{
		if(this.isCamelot)
		{
			return camelot.withdrawEvent(eventId, rsvpId)
		} else {
			return legacy.withdrawEvent(eventId, rsvpId);
		}
	},

	async acceptEvent(inviteId)
	{
		if(this.isCamelot)
		{
			return camelot.acceptEvent(inviteId)
		} else {
			return legacy.acceptEvent(inviteId);
		}
	},

	async declineEvent(inviteId)
	{
		if(this.isCamelot)
		{
			return camelot.declineEvent(inviteId)
		} else {
			return legacy.declineEvent(inviteId);
		}
	},

	async updateComment(rsvpId, eventId, comment)
	{
		if(this.isCamelot)
		{
			return camelot.updateComment(rsvpId, eventId, comment)
		} else {
			return legacy.updateComment(rsvpId, eventId, comment);
		}
	},

	// Shortcuts
	async getShortcuts() {
		if(this.isCamelot)
		{
			return camelot.getShortcuts()
		} else {
			return legacy.getShortcuts();
		}
	},


	async query(options)
	{
		if(this.isCamelot)
		{
			return camelot.query(options)
		} else {
			return legacy.query(options);
		}
	},

	async mutate(options)
	{
		if(this.isCamelot)
		{
			return camelot.mutate(options)
		} else {
			return legacy.mutate(options);
		}
	},

	get jwt()
	{
		if(this.isCamelot)
		{
			return camelot.jwt
		} else {
			return legacy.jwt
		}
	},

	get client()
	{
		if(this.isCamelot)
		{
			return camelot.client
		} else {
			return legacy.client
		}
	}
}

